import axiosInstance from "../../axiosInstance";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
export const getStudentLiveStream = createAsyncThunk(
  "get/studentLiveStream",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/userLiveStreamList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error.response.data);
    }
  }
);
const studentLiveStream = createSlice({
  name: "studentLiveStream",
  initialState: {
    liveStream: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getStudentLiveStream.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStudentLiveStream.fulfilled, (state, action) => {
      state.loading = false;
      state.liveStream = action.payload;
    });
    builder.addCase(getStudentLiveStream.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default studentLiveStream.reducer;
